const VIEWPORT_BASE =
  "width=device-width, initial-scale=1, viewport-fit=cover, interactive-widget=resizes-content";

/**
 * Corrige zoom/scroll residual no iOS após fechar o teclado virtual.
 * Combinar com font-size >= 16px nos inputs para evitar o zoom ao focar.
 */
export function resetMobileViewportAfterKeyboard() {
  if (typeof window === "undefined") return;

  const meta = document.querySelector('meta[name="viewport"]');
  if (meta) {
    meta.setAttribute("content", `${VIEWPORT_BASE}, maximum-scale=1`);
    window.setTimeout(() => {
      meta.setAttribute("content", VIEWPORT_BASE);
    }, 120);
  }

  requestAnimationFrame(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  });
}
